/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PickupWindow
 */
export interface PickupWindow {
    /**
     * 
     * @type {any}
     * @memberof PickupWindow
     */
    id: any | null;
    /**
     * 
     * @type {Date}
     * @memberof PickupWindow
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof PickupWindow
     */
    end: Date;
    /**
     * 
     * @type {Date}
     * @memberof PickupWindow
     */
    cutoffTime: Date;
}

/**
 * Check if a given object implements the PickupWindow interface.
 */
// @ts-ignore
export function instanceOfPickupWindow(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "start" in value;
    isInstance = isInstance && "end" in value;
    isInstance = isInstance && "cutoffTime" in value;

    return isInstance;
}

// @ts-ignore
export function PickupWindowFromJSON(json: any): PickupWindow {
    return PickupWindowFromJSONTyped(json, false);
}

// @ts-ignore
export function PickupWindowFromJSONTyped(json: any, ignoreDiscriminator: boolean): PickupWindow {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
        'cutoffTime': (new Date(json['cutoff_time'])),
    };
}

// @ts-ignore
export function PickupWindowToJSON(value?: PickupWindow | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'start': (value.start.toISOString()),
        'end': (value.end.toISOString()),
        'cutoff_time': (value.cutoffTime.toISOString()),
    };
}

